import { useNavigate } from 'react-router';
import { useAuth } from '@/contexts/AuthContext';

export function CompanySelectScreen() {
  const navigate = useNavigate();
  const { companyList, selectCompany } = useAuth();

  const handleSelectCompany = async (company: { id: number; name: string }) => {
    try {
      await selectCompany(company);
      navigate('/home', { replace: true });
    } catch {
      // Error handled in context
    }
  };

  return (
    <div className="kstc-card kst-card-width kstc-text-center">
      <div className="kstc-card__body">
        <h5 className="kstc-card__title">Select Company</h5>
        <div className="kstc-row">
          <div className="kstc-col-3"></div>
          <div className="kstc-col-6">
            <div className="kstc-d-grid kstc-gap-2">
              {companyList.map((company: any) => (
                <div key={company.id}>
                  <button
                    type="button"
                    className="kstc-btn kstc-btn--primary kstc-btn--lg kstc-mt-2"
                    onClick={() => handleSelectCompany(company)}
                  >
                    {company.name}
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
